<template>
  <div :style="computedBackgroundStyle" v-if="isLoginByInter !== '1'">
    <home-header />
    <personal-center :show_fee="$store.state.homeObj.show_fee" />
    <div v-if="imgUrl && xsbdShow == '1'" class="floating-container">
      <div v-if="show" @mouseover="mouseover" @mouseout="mouseout" class="box" :style="{ top: top + 'px', left: left + 'px' }" ref="boxRef">
        <img @click="gotoStuRegistration" id="floatImg" :src="imgUrl" />
        <span @click="close" class="closeBtn">关闭</span>
      </div>
    </div>
    <div class="pagewidth margin-top-20" style="border: 1px solid transparent; overflow: hidden">
      <div class="row">
        <div class="col-6" v-if="$store.state.homeObj.notice_column_show != '0'">
          <home-news></home-news>
        </div>
        <div class="col-6" v-if="$store.state.homeObj.progress_column_show != '0'">
          <study-rate></study-rate>
        </div>
      </div>
    </div>
    <div class="shell-course-plan" style="margin-top: 16px">
      <course-plan :course="course" :termSet="termSet" :CurrentTime="CurrentTime" v-if="termSet.lengh != 0 && course.length != 0" />
    </div>
    <div class="margin-top-30"></div>
    <Foot />
    <a-modal title="" :width="1000" :visible="infoCheckVisiable" :closable="false" :maskClosable="false" :footer="null">
      <InfoRecheck @refeshModalShow="refeshModalShow" />
    </a-modal>
    <a-modal title="修改密码" :width="800" :visible="changePasswordVisiable" :closable="false" :maskClosable="false" :footer="null">
      <ForgetPassword />
    </a-modal>
  </div>
  <div :style="computedBackgroundStyle" v-else>
    <course-plan :course="course" :termSet="termSet" :CurrentTime="CurrentTime" v-if="termSet.length != 0 && course.length != 0" />
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header';
import PersonalCenter from '@/common/components/PersonalCenter';
import HomeNews from './components/News';
import StudyRate from './components/StudyRate';
import CoursePlan from './components/CoursePlan';
import Foot from '@/common/components/Foot';
import PhoneCheck from './components/PhoneCheck';
import InfoRecheck from './components/infoRecheck.vue';
import ForgetPassword from './components/ForgetPassword.vue';
import { mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    StudyRate,
    HomeHeader,
    Foot,
    HomeNews,
    CoursePlan,
    PersonalCenter,
    PhoneCheck,
    InfoRecheck,
    ForgetPassword,
  },
  data: function() {
    return {
      course: [],
      termSet: [],
      CurrentTime: 0,
      answer: '',
      disabled: true,
      isLoginByInter: '',
      show: true, // 是否展现飘窗
      directionX: 'right', // 飘窗的x轴方向 right left
      directionY: 'down', // 飘窗的Y轴方向 down  up
      stepX: 1, // 水平方向的步长
      stepY: 1, // 垂直方向的步长
      timer: '', // 定时器
      clientHeight: 0, // 最大的 top 值
      clientWidth: 0, // 最大的 left 值
      height: 0, // 元素的高
      width: 0, // 元素的宽
      top: 0, // 头部距离
      left: 0, // 左侧距离,
      imgUrl: '',
      xsbdShow: '',
      infoCheckVisiable: false,
      changePasswordVisiable: false,
      headerBgUrl: '',
    };
  },
  created() {
    this.isLoginByInter = localStorage.getItem('isLoginByInter');
    if (this.$route.name !== 'myPersonalStudyFee' && localStorage.getItem('token')) {
      this.axios.get('/sys/login/userinfo').then(res => {
        let userInfo = res.result.userInfo;
        userInfo.eduLogo = res.result.eduLogo || null;
        userInfo.headTitle = res.result.headTitle;
        userInfo.pageTitle = res.result.pageTitle;
        document.title = `${userInfo.eduName} - ${userInfo.pageTitle}`;
        this.common.setStorage('userInfo', userInfo);
        this.$store.commit('SET_USERINFO', userInfo);
      });
    }
  },
  computed: {
    ...mapState(['city', 'userInfo']),

    // 计算属性生成背景样式
    computedBackgroundStyle() {
      if (localStorage.getItem('themeServer')) {
        this.headerBgUrl = '';
        const headerArr = JSON.parse(localStorage.getItem('themeServer')).filter(item => item.themeCode === 'content_bg');
        if (headerArr.length > 0) {
          if (headerArr[0].color) {
            this.headerBgUrl = headerArr[0].color;
          }
        }
      } else {
        this.axios
          .get(
            `/sys/sysClientStyleConfig/list?clientType=pc&eduCode=${
              localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).eduCode : ''
            }`
          )
          .then(res => {
            this.headerBgUrl = '';
            const headerArr = res.result.filter(item => item.themeCode === 'content_bg');
            if (headerArr.length > 0) {
              if (headerArr[0].color) {
                this.headerBgUrl = headerArr[0].color;
              }
            }
          });
      }

      // 有URL时使用图片
      if (this.headerBgUrl) {
        return {
          backgroundColor: this.headerBgUrl, // 双引号避免URL含特殊字符问题
        };
      }

      // 无URL时使用颜色
      return {
        backgroundColor: '#eaeaea', // 使用CSS变量关联Sass变量
      };
    },
  },
  mounted() {
    if (this.lastCity !== this.city) {
      this.lastCity = this.city;
      if (!localStorage.getItem('token')) {
        this.common.toURL('/login');
        return;
      }
      // 判断是否弹框提示未缴费
      this.judgeNoFeeTip();

      this.goOn();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (!userInfo.phone && userInfo.bindTel === '1') {
        this.bindTelVisiable = true;
      }
      this.getNotify(); // 这是调用页面打开的时候几个通知信息的函数
      this.axios.get(`/biz/home/param`).then(res => {
        if (res.code === 200) {
          this.imgUrl = res.result.xsbd_pic;
          this.xsbdShow = res.result.xsbd_show;
          this.passwordOrInfoShow(res.result.need_change_pwd, res.result.need_archive_confirm);
          if (this.imgUrl && this.xsbdShow === '1') {
            setTimeout(() => {
              this.$nextTick(() => {
                this.init();
                this.onresize();
              });
            }, 100);
          }
        }
      });
    }
  },
  beforeDestroy() {
    // dom 销毁前清除定时器
    clearInterval(this.timer);
  },
  methods: {
    // 初始化飘窗规则
    init() {
      // 获取元素的高度
      this.height = this.$refs.boxRef.offsetHeight;
      // 获取元素的宽度
      this.width = this.$refs.boxRef.offsetWidth;
      // 获取可视屏幕的高度
      this.clientHeight = document.documentElement.clientHeight;
      // 获取可视屏幕的宽度
      this.clientWidth = document.documentElement.clientWidth;
      // 开始移动函数
      this.start();
    },
    refeshModalShow() {
      this.axios.get(`/biz/home/param`).then(res => {
        if (res.code === 200) {
          this.passwordOrInfoShow(res.result.need_change_pwd, res.result.need_archive_confirm);
        }
      });
    },
    // 先修改密码 再确认信息
    passwordOrInfoShow(pwShow, infoShow) {
      this.changePasswordVisiable = pwShow == 1;
      this.infoCheckVisiable = pwShow == 0 && infoShow == 1;
    },
    // 开始设置定时器进行移动
    start() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.timer = setInterval(() => {
        this.move();
      }, 15);
    },
    // 移动函数
    move() {
      // 因为刚开始默元素位置是 0,0 在屏幕的左上角
      // 判断移动方向
      // 1 向右移动时
      if (this.directionX === 'right') {
        // 判断 移动的距离加上元素的宽度加上步长 是否大于 可视屏幕的宽度
        // 如果大于屏幕宽度就表示碰到了 右侧的边界 并进行修改方向
        if (this.left + this.width + this.stepX > this.clientWidth) {
          this.directionX = 'left';
        }
        // 2 向左移动时
      } else {
        // 只需要判断 用之前移动的左侧距离减去步长 当小于0时就表示碰到了左侧的边界
        if (this.left - this.stepX < 0) {
          this.directionX = 'right';
        }
      }
      // 3 向下移动
      if (this.directionY === 'down') {
        // 同理 需要判断当前 距离头部的距离加上元素的高度加上步长 是否大于可视屏幕的高度
        // 如果大于可视屏幕高度就表示碰到了 屏幕底部的边界
        if (this.top + this.height + this.stepY > this.clientHeight) {
          this.directionY = 'up';
        }
        // 4 向上移动
      } else {
        // 只需要判断 用之前移动的头部距离减去步长 当小于0时就表示碰到了屏幕上边的边界
        if (this.top - this.stepY < 0) {
          this.directionY = 'down';
        }
      }

      // 移动操作
      // 向右移动时将左侧的距离根据定时器的触发进行加上每次的步长
      if (this.directionX === 'right') {
        this.left += this.stepX;
        // 向左移动时就需要将之前获取到的左侧距离减去步长
      } else {
        this.left -= this.stepX;
      }
      // 向下移动时将距离头部的距离根据定时器的触发加上每次的步长
      if (this.directionY === 'down') {
        this.top += this.stepY;
        // 向上移动时需要将之前获取到的头部距离减去步长
      } else {
        this.top -= this.stepY;
      }
    },
    // 鼠标悬浮在飘窗时停止移动
    mouseover() {
      clearInterval(this.timer);
    },
    // 鼠标离开飘窗时恢复移动
    mouseout() {
      this.start();
    },
    // 关闭飘窗
    close() {
      clearInterval(this.timer);
      this.show = false;
    },
    // 窗口大小调整时重置飘窗规则
    onresize() {
      const that = this;
      window.onresize = function() {
        that.init();
      };
    },

    gotoStuRegistration() {
      this.axios.get(`/biz/home/quick/xsbd`).then(res => {
        if (res.success) {
          window.open(res.result);
        }
      });
    },

    goOn() {
      this.getHomeInfo(); //获取首页信息
      this.getNotify(); // 这是调用页面打开的时候几个通知信息的函数
      this.axios.get(`/biz/home/param`).then(res => {
        if (res.code === 200) {
          this.imgUrl = res.result.xsbd_pic;
          this.xsbdShow = res.result.xsbd_show;
          if (this.imgUrl && this.xsbdShow === '1') {
            setTimeout(() => {
              this.$nextTick(() => {
                this.init();
                this.onresize();
              });
            }, 100);
          }
        }
      });
    },

    getHomeInfo() {
      this.axios.get(`biz/subject/term/list`).then(res => {
        this.termSet = res.result;
        this.axios.get(`biz/subject/list`).then(res => {
          let data = res.result;
          let set = new Set();
          data.forEach((item, index) => {
            item.isStudyTime = this.judgeDate1(item.studyStart, item.studyEnd, res.timestamp, item.webLearnFlag);
            item.isExamTime = this.judgeDate(item.examStart, item.examEnd, res.timestamp);
            if (item.layoutTermOrder) {
              set.add(item.layoutTermOrder);
            }
          });
          this.CurrentTime = res.timestamp;
          this.course = data;
        });
      });
    },
    judgeDate(start, end, current) {
      let startDate = this.common.format(start);
      let endDate = this.common.format(end);

      if (startDate < current && endDate > current) {
        return true;
      } else {
        return false;
      }
    },

    judgeDate1(start, end, current, webLearnFlag) {
      if (webLearnFlag === 0) {
        return false;
      }
      let startDate = this.common.format(start);
      let endDate = this.common.format(end);

      if (startDate < current && endDate > current) {
        return true;
      } else {
        return false;
      }
    },
    getHomeInfoSucc: function(res) {
      res = res.data;
      if (res.ret && res.data) {
        const data = res.data;
        this.course = data.course;
      }
    },
    getNotify() {
      this.axios
        .get(`/biz/user/notify/page`, {
          params: { delFlag: 0, isRead: 0, pageNo: 1, pageSize: 10 },
        })
        .then(res => {
          if (res.result.records.length > 0) {
            let data = res.result.records;
            data.forEach(nt => {
              let verifyMode = nt.eduNotify.verifyMode;
              switch (verifyMode) {
                case 0:
                  // this.noVerify(nt)
                  break;
                case 1:
                  this.stayVerify(nt);
                  break;
                case 2:
                  this.questionVerify(nt);
                  break;
                case 3:
                  this.redVerify(nt);
                  break;
                default:
                  break;
              }
            });
          }
        });
    },
    noVerify(data) {
      let content = (
        <div class="notify-content">
          <div class="notify-info" domPropsInnerHTML={data.eduNotify.content}></div>
        </div>
      );
      this.$info({
        title: '通知消息',
        icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
        keyboard: false,
        content: content,
        okButtonProps: { style: { background: '#2CAF7A', border: '#2CAF7A' } },
        width: 800,
        onOk: () => {
          this.axios.get(`/biz/user/notify/confirm?id=${data.id}`);
        },
      });
    },
    questionVerify(data) {
      let inputChange = e => {
        if (e.target.value === data.eduNotify.answer) {
          modal.update({
            okButtonProps: {
              props: { disabled: false },
              style: { background: '#2CAF7A', border: '#2CAF7A' },
            },
          });
        } else {
          modal.update({
            okButtonProps: { props: { disabled: true } },
          });
        }
      };
      let content = (
        <div class="notify-content">
          <div class="notify-info" domPropsInnerHTML={data.eduNotify.content}></div>
          <a-divider />
          <div class="verify">
            <div class="question">{data.eduNotify.question}</div>
            <div class="answer">
              <a-input on-change={inputChange} placeholder="请输入上述问题的正确答案" />
            </div>
            <div class="question-info">(*请先回答问题再点击关闭按钮)</div>
          </div>
        </div>
      );
      let modal = this.$info({
        title: '通知消息',
        icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
        keyboard: false,
        content: content,
        width: 800,
        okButtonProps: { props: { disabled: true } },
        onOk: () => {
          this.axios.get(`/biz/user/notify/confirm?id=${data.id}`);
        },
      });
    },
    stayVerify(data) {
      let duration = data.eduNotify.staySeconds;
      let notify = null;
      if (!duration) {
        notify = <div className="notify"></div>;
      } else {
        notify = (
          <div className="notify">
            剩余<span class="second">{duration}</span>秒后可关闭
          </div>
        );
      }
      let info = <div style={{ overflowX: 'auto' }} domPropsInnerHTML={data.eduNotify.content}></div>;
      let content = (
        <div class="ant-message-custom-content">
          {info}
          {notify}
        </div>
      );
      let modal = this.$info({
        title: '通知消息',
        content: content,
        icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
        width: 1300,
        okButtonProps: { props: { disabled: true } },
        onOk: () => {
          this.axios.get(`/biz/user/notify/confirm?id=${data.id}`);
        },
      });
      let timer = setInterval(() => {
        duration--;
        if (!duration) {
          notify = <div className="notify"></div>;
        } else {
          notify = (
            <div className="notify">
              剩余<span class="second">{duration}</span>秒后可关闭
            </div>
          );
        }
        let content = (
          <div>
            {info}
            <a-divider />
            {notify}
          </div>
        );
        if (duration <= 0) {
          clearInterval(timer);
          modal.update({
            content: content,
            okButtonProps: {
              props: { disabled: false },
              style: { background: '#2CAF7A', border: '#2CAF7A' },
            },
          });
        } else {
          modal.update({
            content: content,
          });
        }
      }, 1000);
    },
    redVerify(data) {
      let inputChange = e => {
        if (e.target.value === data.eduNotify.answer) {
          modal.update({
            okButtonProps: {
              props: { disabled: false },
              style: { background: '#2CAF7A', border: '#2CAF7A' },
            },
          });
        } else {
          modal.update({
            okButtonProps: { props: { disabled: true } },
          });
        }
      };
      let content = (
        <div class="notify-content">
          <div class="notify-info" domPropsInnerHTML={data.eduNotify.content}></div>
          <a-divider />
          <div class="verify">
            <div class="question">请输入上述通知消息中的红字内容再点击知道了关闭通知窗口</div>
            <div class="answer">
              <a-input on-change={inputChange} placeholder="请输入上述通知消息中的红字内容" />
            </div>
          </div>
        </div>
      );
      let modal = this.$info({
        title: '通知消息',
        icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
        keyboard: false,
        content: content,
        width: 800,
        okButtonProps: { props: { disabled: true } },
        onOk: () => {
          this.axios.get(`/biz/user/notify/confirm?id=${data.id}`);
        },
      });
    },
    /* 如果学生没有绑定手机号码，在打开首页的时候强制先绑定手机号码 */
    creatModal() {
      let content = (
        <div class="notify-content">
          <a-divider />
          <PhoneCheck />
        </div>
      );

      this.$info({
        title: '绑定手机号',
        icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
        keyboard: false,
        content: content,
        okButtonProps: { style: { background: '#2CAF7A', border: '#2CAF7A' } },
        width: 1000,
        okText: '关闭',
        footer: 'null',
        maskClosable: false,
        onOk: () => {
          let userInfo = JSON.parse(localStorage.getItem('userInfo'));
          if (!userInfo.phone) {
            this.$message.success('您好，根据《中华人民共和国网络安全法》及相关法律规定，\n' + '请您填写正确的手机号进行认证，获取更多网络服务。', 1000);
            $this.visible(true); // 没有绑定手机点击ok按钮不能关闭弹出层
          }
        },
      });
    },

    // 判断是否显示未缴费弹框
    judgeNoFeeTip() {
      const that = this;
      const tipsObj = JSON.parse(localStorage.getItem('tipsObj'));
      if (tipsObj && tipsObj.isShowNoFeeTips === '1') {
        let content = (
          <div class="notify-content">
            <div class="notify-info" domPropsInnerHTML={tipsObj.noFeeTipsText}></div>
          </div>
        );
        that.$info({
          title: '系统消息',
          icon: () => <a-icon type="bell" style={{ color: '#2CAF7A' }} />,
          keyboard: false,
          content: content,
          okButtonProps: {
            style: { background: '#2CAF7A', border: '#2CAF7A' },
          },
          width: 800,
          onOk: () => {
            that.axios.get(`/biz/tips/addTipsLog?type=0`).then(res => {
              if (res.success) {
                localStorage.removeItem('tipsObj');
              }
            });
          },
        });
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.floating-container {
  cursor: pointer;

  .box {
    position: relative;
    box-sizing: border-box;
    z-index: 2000;
    width: 300px;
    height: 200px;
    border-radius: 5px;
    position: fixed;
    text-align: left;
    color: #ffffff;
    top: 0;
    left: 0;

    img {
      max-width: 100%; /* 图片的最大宽度为父容器的100% */
      height: auto; /* 自动调整高度以保持原始比例 */
    }

    .closeBtn {
      position: absolute;
      color: #666;
      right: 0;
      bottom: -18px;
    }
  }
}

.pagewidth {
  width: 1330px;
  margin: 0 auto;
}

.notify-content {
  // padding: 20px;
}

.notify-info {
  font-size: 15px;
  margin-top: 20px;
  overflow-x: auto;
}

.verify {
  display: flex;
  align-items: center;
}

.question-info {
  font-size: 12px;
  color: #666666;
  margin-left: 10px;
  color: #f00;
}

.question {
  background: $bgColor;
  color: #fff;
  flex: 1;
  padding: 5px 20px;
  margin-right: 10px;
  border-radius: 5px;
}

.answer {
  width: 50%;
  flex: 1;
}

.ant-btn-primary {
  background: $bgColor !important;
}

.ant-divider-horizontal {
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: 1px;
  margin: 10px 0;
}

.second {
  color: $bgColor;
  font-weight: bold;
}

.shell-course-plan {
  min-height: calc(100vh - 895px);
}

.ant-message-custom-content {
  max-width: 100%; /* 或者具体的最大宽度 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ant-message-custom-content image {
  width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue